import React from "react";
import "./Carsel.scss";

const Carsel = () => {
  return (
    <div className="main_carsel">
      <p style={{textAlign:"center" , color:"#DDC861" , fontWeight:"bold" , margin:"0 0 2.5rem 0"}}>ABOUT FLUX</p>
      <div className="carsel_para">
        Africa's First Electric Car Debuts in Nigeria. Revolving technology moves us to think beyond mobility, and design for a world where life is the most important journey we’ll ever take; to look beyond tomorrow and shape a future where we no longer have to choose between doing great things and doing the right thing; and to explore beyond ourselves, and create experiences that remind us what it’s like to feel truly alive.
      </div>

    </div>
  );
};

export default Carsel;
